import { countries } from 'src/features/details-form/constants';

const isoToCountryLabel: Record<string, string> = {
    AF: 'countries_afghanistan',
    AL: 'countries_albania',
    DZ: 'countries_algeria',
    AD: 'countries_andorra',
    AO: 'countries_angola',
    AG: 'countries_antigua_deps',
    AR: 'countries_argentina',
    AM: 'countries_armenia',
    AU: 'countries_australia',
    AT: 'countries_austria',
    AZ: 'countries_azerbaijan',
    BS: 'countries_bahamas',
    BH: 'countries_bahrain',
    BD: 'countries_bangladesh',
    BB: 'countries_barbados',
    BY: 'countries_belarus',
    BE: 'countries_belgium',
    BZ: 'countries_belize',
    BJ: 'countries_benin',
    BT: 'countries_bhutan',
    BO: 'countries_bolivia',
    BA: 'countries_bosnia_herzegovina',
    BW: 'countries_botswana',
    BR: 'countries_brazil',
    BN: 'countries_brunei',
    BG: 'countries_bulgaria',
    BF: 'countries_burkina',
    BI: 'countries_burundi',
    KH: 'countries_cambodia',
    CM: 'countries_cameroon',
    CA: 'countries_canada',
    CV: 'countries_cape_verde',
    CF: 'countries_central_african_rep',
    TD: 'countries_chad',
    CL: 'countries_chile',
    CN: 'countries_china',
    CO: 'countries_colombia',
    KM: 'countries_comoros',
    CG: 'countries_congo',
    CD: 'countries_congo_democratic_rep',
    CR: 'countries_costa_rica',
    HR: 'countries_croatia',
    CU: 'countries_cuba',
    CY: 'countries_cyprus',
    CZ: 'countries_czech_republic',
    DK: 'countries_denmark',
    DJ: 'countries_djibouti',
    DM: 'countries_dominica',
    DO: 'countries_dominican_republic',
    TL: 'countries_east_timor',
    EC: 'countries_ecuador',
    EG: 'countries_egypt',
    SV: 'countries_el_salvador',
    GQ: 'countries_equatorial_guinea',
    ER: 'countries_eritrea',
    EE: 'countries_estonia',
    ET: 'countries_ethiopia',
    FJ: 'countries_fiji',
    FI: 'countries_finland',
    FR: 'countries_france',
    GA: 'countries_gabon',
    GM: 'countries_gambia',
    GE: 'countries_georgia',
    DE: 'countries_germany',
    GH: 'countries_ghana',
    GR: 'countries_greece',
    GD: 'countries_grenada',
    GT: 'countries_guatemala',
    GN: 'countries_guinea',
    GW: 'countries_guinea_bissau',
    GY: 'countries_guyana',
    HT: 'countries_haiti',
    HN: 'countries_honduras',
    HK: 'countries_hong_kong',
    HU: 'countries_hungary',
    IS: 'countries_iceland',
    IN: 'countries_india',
    ID: 'countries_indonesia',
    IR: 'countries_iran',
    IQ: 'countries_iraq',
    IE: 'countries_ireland_republic',
    IL: 'countries_israel',
    IT: 'countries_italy',
    CI: 'countries_ivory_coast',
    JM: 'countries_jamaica',
    JP: 'countries_japan',
    JO: 'countries_jordan',
    KZ: 'countries_kazakhstan',
    KE: 'countries_kenya',
    KI: 'countries_kiribati',
    KP: 'countries_korea_north',
    KR: 'countries_korea_south',
    XK: 'countries_kosovo',
    KW: 'countries_kuwait',
    KG: 'countries_kyrgyzstan',
    LA: 'countries_laos',
    LV: 'countries_latvia',
    LB: 'countries_lebanon',
    LS: 'countries_lesotho',
    LR: 'countries_liberia',
    LY: 'countries_libya',
    LI: 'countries_liechtenstein',
    LT: 'countries_lithuania',
    LU: 'countries_luxembourg',
    MK: 'countries_macedonia',
    MG: 'countries_madagascar',
    MW: 'countries_malawi',
    MY: 'countries_malaysia',
    MV: 'countries_maldives',
    ML: 'countries_mali',
    MT: 'countries_malta',
    MH: 'countries_marshall_islands',
    MR: 'countries_mauritania',
    MU: 'countries_mauritius',
    MX: 'countries_mexico',
    FM: 'countries_micronesia',
    MD: 'countries_moldova',
    MC: 'countries_monaco',
    MN: 'countries_mongolia',
    ME: 'countries_montenegro',
    MA: 'countries_morocco',
    MZ: 'countries_mozambique',
    MM: 'countries_myanmar_burma',
    NA: 'countries_namibia',
    NR: 'countries_nauru',
    NP: 'countries_nepal',
    NL: 'countries_netherlands',
    NZ: 'countries_new_zealand',
    NI: 'countries_nicaragua',
    NE: 'countries_niger',
    NG: 'countries_nigeria',
    NO: 'countries_norway',
    OM: 'countries_oman',
    PK: 'countries_pakistan',
    PW: 'countries_palau',
    PA: 'countries_panama',
    PG: 'countries_papua_new_guinea',
    PY: 'countries_paraguay',
    PE: 'countries_peru',
    PH: 'countries_philippines',
    PL: 'countries_poland',
    PT: 'countries_portugal',
    QA: 'countries_qatar',
    RO: 'countries_romania',
    RU: 'countries_russian_federation',
    RW: 'countries_rwanda',
    KN: 'countries_st_kitts_nevis',
    LC: 'countries_st_lucia',
    VC: 'countries_saint_vincent_the_grenadines',
    WS: 'countries_samoa',
    SM: 'countries_san_marino',
    ST: 'countries_sao_tome_principe',
    SA: 'countries_saudi_arabia',
    SN: 'countries_senegal',
    RS: 'countries_serbia',
    SC: 'countries_seychelles',
    SL: 'countries_sierra_leone',
    SG: 'countries_singapore',
    SK: 'countries_slovakia',
    SI: 'countries_slovenia',
    SB: 'countries_solomon_islands',
    SO: 'countries_somalia',
    ZA: 'countries_south_africa',
    SS: 'countries_south_sudan',
    ES: 'countries_spain',
    LK: 'countries_sri_lanka',
    SD: 'countries_sudan',
    SR: 'countries_suriname',
    SZ: 'countries_swaziland',
    SE: 'countries_sweden',
    CH: 'countries_switzerland',
    SY: 'countries_syria',
    TW: 'countries_taiwan',
    TJ: 'countries_tajikistan',
    TZ: 'countries_tanzania',
    TH: 'countries_thailand',
    TG: 'countries_togo',
    TO: 'countries_tonga',
    TT: 'countries_trinidad_tobago',
    TN: 'countries_tunisia',
    TR: 'countries_turkey',
    TM: 'countries_turkmenistan',
    TV: 'countries_tuvalu',
    UG: 'countries_uganda',
    UA: 'countries_ukraine',
    AE: 'countries_united_arab_emirates',
    GB: 'countries_united_kingdom',
    US: 'countries_united_states',
    UY: 'countries_uruguay',
    UZ: 'countries_uzbekistan',
    VU: 'countries_vanuatu',
    VA: 'countries_vatican_city',
    VE: 'countries_venezuela',
    VN: 'countries_vietnam',
    YE: 'countries_yemen',
    ZM: 'countries_zambia',
    ZW: 'countries_zimbabwe',
};

export function parseCountryIso(isoCode: string): string | undefined {
    if (!isoCode) return undefined;
    const normalizedIsoCode = isoCode.trim().toUpperCase();
    if (!normalizedIsoCode) return undefined;

    const labelKey = isoToCountryLabel[normalizedIsoCode];
    if (!labelKey) return undefined;

    const country = countries.find((c: { value: string; label: string }) => c.label === labelKey);
    return country ? country.value : undefined;
}
